import { FileUpload } from '.';

export interface ClientSupport {
  id?: number;
  clientId: string;
  contactInfo?: string;
  fileUploadId?: number;
  userManual?: FileUpload;
}
